import type { Person } from "@/services/api";

export const getFullStreetNameFromContactAddress = (
  address: Person["addresses"][number],
): string => {
  const addressString = [
    address.addressStreet1,
    address.addressStreet2,
    address.addressCity,
    address.addressCountry,
    address.addressPostalCode,
  ]
    .filter(Boolean)
    .join(", ");
  return addressString;
};
